import { TInvalidStateErrorFactory } from '../types';

export const createInvalidStateError: TInvalidStateErrorFactory = () => new DOMException('', 'InvalidStateError');
